import { useMutation } from "@apollo/client";
import {
  UPDATE_APPLICANT_DETAILS,
  UPDATE_APPLICANT_EMPLOYMENT,
  UPDATE_EXPENDITURE,
  UPDATE_BROKER_DETAILS,
  UPDATE_LOAN_DETAILS,
  UPDATE_OTHER_DETAILS,
  UPDATE_PROPERTY_DETAILS,
  UPDATE_PRODUCT,
  UPDATE_REVIEW_CONFIRM,
} from "api/mutations/application";

const useApiStepBroker = () => useMutation(UPDATE_BROKER_DETAILS);
const useApiStepApplicants = () => useMutation(UPDATE_APPLICANT_DETAILS);
const useApiStepApplicantEmployment = () =>
  useMutation(UPDATE_APPLICANT_EMPLOYMENT);
const useApiStepExpenditure = () => useMutation(UPDATE_EXPENDITURE);
const useApiStepLoan = () => useMutation(UPDATE_LOAN_DETAILS);
const useApiStepProperty = () => useMutation(UPDATE_PROPERTY_DETAILS);
const useApiStepOther = () => useMutation(UPDATE_OTHER_DETAILS);
const useApiStepProduct = () => useMutation(UPDATE_PRODUCT);
const useApiStepConfirm = () => useMutation(UPDATE_REVIEW_CONFIRM);

export const mutationHooks: { [k: string]: Function } = {
  broker: useApiStepBroker,
  applicants: useApiStepApplicants,
  employments: useApiStepApplicantEmployment,
  expenditure: useApiStepExpenditure,
  loan: useApiStepLoan,
  property: useApiStepProperty,
  other: useApiStepOther,
  product: useApiStepProduct,
  confirm: useApiStepConfirm,
};
